    import React from 'react'
    import {Box, Button, Grid, Typography} from "@mui/material";
    import useStyles from "../../assets/styles/HomeStyles";

    const DQProSalesResources = () => {
        const classes = useStyles();
        const cards = [
            {
                title: "DQ Scoring Rubrics and Suggestions for Client Consultation",
                description: "Understand what DQ Scores mean so you can follow up with your clients and consult them on next steps after they’ve taken the assessments.",
                button: {
                    text: "Coming Soon",
                    link: null
                },
            },
            {
                title: "Editable Standard Sales Deck",
                description: "Standard PPT sales deck that you can edit and adjust to sell to your schools, organizations, and communities.",
                button: {
                    text: "Download",
                    link: "https://storage.googleapis.com/poweredbydq/resources/AI%20Readiness%20for%20Youth%20-%20Sample%20Schools%20Deck.pptx"
                },
            },
            {
                title: "CSV Instructions for Your Clients",
                description: "Detailed document you can share with your clients on how to set up their learners’ accounts.",
                button: {
                    text: "Download",
                    link: "https://storage.googleapis.com/poweredbydq/resources/CSV%20Instructions%20for%20Admin_%20User%20Account%20Creation.pdf"
                },
            },
            {
                title: "Parental Data Consent Forms and Letters",
                description: "Template consent forms and letters for parents if you’re dealing with schools minors directly.",
                button: {
                    text: "Download",
                    link: "https://storage.googleapis.com/poweredbydq/resources/Sample%20Parental%20Consent%20Form%20and%20Letter%20for%20Assessments%20v1.pdf"
                }
            },
        ];
    
        return (
            <Box className={classes.pageContainer} style={{marginTop:'auto'}}>
                <Typography variant="h2" className={classes.title} sx={{ mb: 4 }}>
                    Sales Resources
                </Typography>
    
                <Grid container spacing={4}>
                    {cards.map((card, index) => (
                        <Grid item xs={12} sm={6} md={3} key={index} >
                            <Box
                                sx={{
                                    p: 3,
                                    height: '450px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    minHeight: '400px',

                                }}
                            >
                                <Box sx={{ minHeight: {sm:'135px', md:'210px', lg:'153px'}, display: 'flex', alignItems: 'flex-start' }}>
                                    <Typography
                                        variant="h4"
                                        sx={{
                                            fontWeight: 'bold',
                                            fontSize: '30px',
                                            color: '#000000',
                                        }}
                                    >
                                        {card.title}
                                    </Typography>
                                </Box>

                                <Box sx={{ minHeight: {sm:'165px',md:'280px',lg:'256px'}, display: 'flex', alignItems: 'flex-start' }}>
                                    <Typography
                                        sx={{
                                            fontSize: '19px',
                                            textAlign:'left',
                                        }}
                                    >
                                        {card.description}
                                    </Typography>
                                </Box>

                                {/* Button aligned at bottom */}
                                <Box sx={{ mt: 'auto', width: '100%' }}>
                                    {card.button && (
                                        <Button
                                            variant="contained"
                                            href={card.button.link}
                                            download
                                            target="_blank" // Open in new tab (optional)
                                            rel="noopener noreferrer" // Security best practice
                                            sx={{
                                                backgroundColor: '#ff6468',
                                                width: '100%',
                                                fontWeight: 'bold',
                                                fontSize: '16px',
                                                borderRadius: '20px',
                                                '&:hover': {
                                                    backgroundColor: '#e05559', // Slightly darker on hover
                                                    color: '#ffffff'
                                                }
                                            }}
                                        >
                                            {card.button.text}
                                        </Button>
                                    )}
                                </Box>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        );
    }
    
    export default DQProSalesResources;